import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import _ from 'lodash';

momentLocalizer(moment);

const roundTo = (n, digits) => {
  if (digits === undefined) {
    digits = 0;
  }

  const multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  const test = (Math.round(n) / multiplicator);
  return +(test.toFixed(2));
};

const formatExportData = (data) => {
  const formatedData = [];
  if (Array.isArray(data)) {
    const headerRow = ['Invoice No.', 'Order No.', 'Customer #', 'Customer Name', 'Shipped', 'Final $$', 'Sale Status', 'Payment Status', 'Sales Margin', 'Sales Profit', 'Sales Person'];
    formatedData.push(headerRow);
    let total = 0;
    let totalSale = 0;
    const reversedData = _.map(data, _.clone);
    reversedData.reverse();
    reversedData.map((row) => {
      const rowData = {};
      rowData.date = moment(row.DispatchDate).format('MMM DD YYYY');
      // flip the sign for return/credit invoices
      if (row.SONum === null) {
        rowData.finalPrice = -row.FinalPrice;
      } else {
        rowData.finalPrice = row.FinalPrice;
      }

      if (row.SaleStatus !== 'Void' && row.SONum !== null) {
        totalSale += rowData.finalPrice;
      }
      // calculate total (include sale and return and credit)
      if (row.SaleStatus !== 'Void') {
        total += rowData.finalPrice;
        rowData.finalPrice = `$${roundTo(rowData.finalPrice || 0, 2).toFixed(2)}`;
      } else {
        rowData.finalPrice = '-';
      }
      formatedData.push([
        row.InvoiceNum || '',
        row.SONum || '',
        row.CustomerNum || '',
        row.Customer_Name || '',
        rowData.date || '',
        rowData.finalPrice || '-',
        row.SaleStatus || '',
        row.PaymentStatusRecord || '',
        row.SalesMargin ? `${row.SalesMargin}%` : '',
        row.SalesProfit || '',
        row.Sales_Username || '',
      ]);
    });
    // formatedData.push(['TOTAL: ', '', '', '', `$${totalSale}`]);
    formatedData.push(['TOTAL: ', '', '', '', `$${roundTo(total, 2).toFixed(2)}`]);
  }
  return formatedData;
};

export { formatExportData };



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesInvoiceExport.js